(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["order-lookup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const textEncoder = new TextEncoder();

    const encodeBase64Url = (value) => {
      let binary = '';
      const bytes = value instanceof Uint8Array ? value : new Uint8Array(value);
      for (let index = 0; index < bytes.length; index += 1) binary += String.fromCharCode(bytes[index]);
      return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');
    };

    const createElement = (tag, className, text) => {
      const element = document.createElement(tag);
      if (className) element.className = className;
      if (text !== undefined && text !== null) element.textContent = String(text);
      return element;
    };

    class OrderLookup extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.form = this.querySelector('[data-order-lookup-form]');
        this.proofType = this.querySelector('[data-proof-type]');
        this.proofValue = this.querySelector('[data-proof-value]');
        this.proofLabel = this.querySelector('[data-proof-label]');
        this.submitButton = this.querySelector('[data-submit]');
        this.submitLabel = this.querySelector('[data-submit-label]');
        this.spinner = this.querySelector('[data-spinner]');
        this.notice = this.querySelector('[data-notice]');
        this.results = this.querySelector('[data-results]');
        this.summary = this.querySelector('[data-summary]');
        this.itemsSection = this.querySelector('[data-items-section]');
        this.packagesSection = this.querySelector('[data-packages-section]');
        this.config = this.readJson('[data-order-lookup-config]');
        this.i18n = this.readJson('[data-order-lookup-i18n]');
        this.sectionId = this.dataset.sectionId || 'order-lookup';
        this.locale = document.documentElement.lang || 'en';
        this.form.addEventListener('submit', (event) => this.handleSubmit(event));
        this.proofType.addEventListener('change', () => this.updateProofField());
        this.updateProofField();
      }

      readJson(selector) {
        try {
          return JSON.parse(this.querySelector(selector).textContent);
        } catch (_error) {
          return {};
        }
      }

      updateProofField() {
        const isEmail = this.proofType.value === 'email';
        this.proofLabel.textContent = isEmail ? this.i18n.email : this.i18n.postalCode;
        this.proofValue.type = isEmail ? 'email' : 'text';
        this.proofValue.inputMode = isEmail ? 'email' : 'text';
        this.proofValue.autocomplete = isEmail ? 'email' : 'postal-code';
        this.proofValue.maxLength = isEmail ? 254 : 32;
        this.proofValue.placeholder = isEmail ? this.i18n.emailPlaceholder : this.i18n.postalPlaceholder;
      }

      validateForm() {
        const orderName = this.form.elements.order_name.value.trim();
        const proofValue = this.proofValue.value.trim();
        if (!orderName || !proofValue) {
          this.showNotice(this.i18n.required);
          return null;
        }
        if (this.proofType.value === 'email' && !this.proofValue.validity.valid) {
          this.showNotice(this.i18n.invalidEmail);
          return null;
        }
        return { orderName, proofType: this.proofType.value, proofValue };
      }

      async handleSubmit(event) {
        event.preventDefault();
        this.hideNotice();
        const values = this.validateForm();
        if (!values) return;
        if (!window.crypto?.subtle || typeof window.crypto.randomUUID !== 'function') {
          this.showNotice(this.i18n.browserUnsupported);
          return;
        }

        this.setLoading(true);
        this.results.hidden = true;
        try {
          const detail = await this.queryOrder(values);
          this.renderOrder(detail);
          this.results.hidden = false;
          this.results.focus({ preventScroll: true });
          this.results.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } catch (error) {
          this.showNotice(this.messageForError(error));
        } finally {
          this.setLoading(false);
        }
      }

      async queryOrder(values) {
        const apiBase = this.getApiBase();
        const bootstrapResponse = await fetch(`${apiBase}/v1/order-details/bootstrap`, {
          method: 'POST',
          mode: 'cors',
          credentials: 'omit',
          cache: 'no-store',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ shop: this.config.shop })
        });
        if (!bootstrapResponse.ok) throw await this.createApiError(bootstrapResponse);
        const bootstrap = await bootstrapResponse.json();
        this.validateBootstrap(bootstrap);

        const payload = {
          ticket: bootstrap.queryTicket,
          nonce: window.crypto.randomUUID(),
          shop: this.config.shop,
          orderName: values.orderName,
          proofType: values.proofType,
          proofValue: values.proofValue,
          iat: new Date().toISOString()
        };
        const compactJwe = await this.createCompactJwe(payload, bootstrap);
        const queryResponse = await fetch(`${apiBase}/v1/order-details/query`, {
          method: 'POST',
          mode: 'cors',
          credentials: 'omit',
          cache: 'no-store',
          headers: { 'Content-Type': 'application/jose', Accept: 'application/json' },
          body: compactJwe
        });
        if (!queryResponse.ok) throw await this.createApiError(queryResponse);
        const detail = await queryResponse.json();
        if (!detail || typeof detail !== 'object' || !detail.orderName) throw new Error('INVALID_RESPONSE');
        return detail;
      }

      getApiBase() {
        const url = new URL(String(this.config.apiBase || '').replace(/\/+$/, ''));
        if (url.protocol !== 'https:') throw new Error('INVALID_RESPONSE');
        return url.toString().replace(/\/$/, '');
      }

      validateBootstrap(bootstrap) {
        if (
          !bootstrap ||
          typeof bootstrap.queryTicket !== 'string' ||
          bootstrap.alg !== 'RSA-OAEP-256' ||
          bootstrap.enc !== 'A256GCM' ||
          !bootstrap.jwk ||
          bootstrap.jwk.kty !== 'RSA' ||
          typeof bootstrap.jwk.kid !== 'string'
        ) throw new Error('INVALID_RESPONSE');
      }

      async createCompactJwe(payload, bootstrap) {
        const protectedHeader = encodeBase64Url(textEncoder.encode(JSON.stringify({
          alg: bootstrap.alg,
          enc: bootstrap.enc,
          kid: bootstrap.jwk.kid
        })));
        const rsaKey = await window.crypto.subtle.importKey(
          'jwk',
          bootstrap.jwk,
          { name: 'RSA-OAEP', hash: 'SHA-256' },
          false,
          ['encrypt']
        );
        const contentKey = await window.crypto.subtle.generateKey(
          { name: 'AES-GCM', length: 256 },
          true,
          ['encrypt']
        );
        const rawContentKey = await window.crypto.subtle.exportKey('raw', contentKey);
        const encryptedKey = await window.crypto.subtle.encrypt({ name: 'RSA-OAEP' }, rsaKey, rawContentKey);
        const iv = window.crypto.getRandomValues(new Uint8Array(12));
        const encryptedContent = new Uint8Array(await window.crypto.subtle.encrypt(
          {
            name: 'AES-GCM',
            iv,
            additionalData: textEncoder.encode(protectedHeader),
            tagLength: 128
          },
          contentKey,
          textEncoder.encode(JSON.stringify(payload))
        ));
        const tagLength = 16;
        const ciphertext = encryptedContent.slice(0, encryptedContent.length - tagLength);
        const authenticationTag = encryptedContent.slice(encryptedContent.length - tagLength);
        return [
          protectedHeader,
          encodeBase64Url(encryptedKey),
          encodeBase64Url(iv),
          encodeBase64Url(ciphertext),
          encodeBase64Url(authenticationTag)
        ].join('.');
      }

      async createApiError(response) {
        let code = '';
        try {
          const body = await response.json();
          code = typeof body.code === 'string' ? body.code : '';
        } catch (_error) {
          code = '';
        }
        const error = new Error(code || `HTTP_${response.status}`);
        error.status = response.status;
        error.code = code;
        return error;
      }

      messageForError(error) {
        if (error?.status === 404 || error?.code === 'ORDER_NOT_FOUND_OR_VERIFICATION_FAILED') return this.i18n.orderNotFound;
        if (error?.status === 429 || error?.code === 'RATE_LIMITED') return this.i18n.rateLimited;
        if (error?.status === 403 || error?.code === 'ORIGIN_NOT_ALLOWED') return this.i18n.originNotAllowed;
        if (error?.status === 400 || error?.status === 401 || error?.code === 'INVALID_REQUEST') return this.i18n.invalidRequest;
        if (error?.status === 503 || error?.code === 'TEMPORARILY_UNAVAILABLE' || error?.message === 'INVALID_RESPONSE') return this.i18n.temporarilyUnavailable;
        return this.i18n.networkError;
      }

      setLoading(loading) {
        this.submitButton.disabled = loading;
        this.submitButton.setAttribute('aria-busy', String(loading));
        this.submitLabel.textContent = loading ? this.i18n.searching : this.i18n.search;
        this.spinner.hidden = !loading;
      }

      showNotice(message) {
        this.notice.textContent = message;
        this.notice.hidden = false;
      }

      hideNotice() {
        this.notice.hidden = true;
        this.notice.textContent = '';
      }

      renderOrder(detail) {
        this.summary.replaceChildren();
        this.itemsSection.replaceChildren();
        this.packagesSection.replaceChildren();
        const items = Array.isArray(detail.items) ? detail.items : [];
        this.renderSummary(detail);
        this.renderItems(items);
        this.renderPackages(Array.isArray(detail.packages) ? detail.packages : []);
      }

      renderSummary(detail) {
        const top = createElement('div', 'order-lookup__summary-top');
        const title = createElement('h2', '', `${this.i18n.resultsFor} ${detail.orderName}`);
        top.append(title, this.createBadge(detail.orderStatus));
        const facts = createElement('dl', 'order-lookup__facts');
        facts.append(
          this.createFact(this.i18n.paymentStatus, this.statusText(detail.paymentStatus)),
          this.createFact(this.i18n.fulfillmentStatus, this.statusText(detail.fulfillmentStatus)),
          this.createFact(this.i18n.orderDate, this.formatDate(detail.createdAt, true))
        );
        this.summary.append(top, facts);
      }

      renderItems(items) {
        const heading = createElement('div', 'order-lookup__section-heading');
        heading.append(
          createElement('h2', '', this.i18n.items),
          createElement('span', 'order-lookup__count', String(items.length))
        );
        const list = createElement('div', 'order-lookup__items');
        items.forEach((item) => list.append(this.createItem(item)));
        this.itemsSection.append(heading, list);
      }

      createItem(item) {
        const article = createElement('article', 'order-lookup__item');
        const imageUrl = this.safeImageUrl(item.imageUrl);
        const productUrl = this.safeProductUrl(item.productUrl, item.handle || item.productHandle);
        let media;
        if (imageUrl) {
          const image = createElement('img', 'order-lookup__item-image');
          image.src = imageUrl;
          image.alt = `${item.name || this.i18n.items} ${this.i18n.imageAlt}`;
          image.loading = 'lazy';
          image.width = 152;
          image.height = 152;
          media = image;
        } else {
          media = createElement('div', 'order-lookup__item-placeholder', String(item.name || '?').charAt(0).toUpperCase());
        }
        if (productUrl) {
          const mediaLink = createElement('a', 'order-lookup__item-media');
          mediaLink.href = productUrl;
          mediaLink.append(media);
          article.append(mediaLink);
        } else {
          article.append(media);
        }
        const content = createElement('div');
        const itemName = createElement(productUrl ? 'a' : 'p', productUrl ? 'order-lookup__item-name-link' : 'order-lookup__item-name', item.name || '—');
        if (productUrl) itemName.href = productUrl;
        content.append(itemName);
        const meta = createElement('ul', 'order-lookup__item-meta');
        if (item.variantTitle) meta.append(createElement('li', '', `${this.i18n.variant}: ${item.variantTitle}`));
        if (item.sku) meta.append(createElement('li', '', `${this.i18n.sku}: ${item.sku}`));
        content.append(meta);
        article.append(content, createElement('span', 'order-lookup__item-quantity', `× ${Number(item.quantity) || 0}`));
        return article;
      }

      renderPackages(packages) {
        const heading = createElement('div', 'order-lookup__section-heading');
        heading.append(
          createElement('h2', 'order-lookup__packages-title', this.i18n.packages),
          createElement('span', 'order-lookup__count', String(packages.length))
        );
        this.packagesSection.append(heading);
        if (!packages.length) {
          this.packagesSection.append(createElement('p', 'order-lookup__empty', this.i18n.noPackages));
          return;
        }
        if (packages.length === 1) {
          this.packagesSection.append(this.createPackage(packages[0], 0));
          return;
        }

        const tabs = createElement('div', 'order-lookup__package-tabs');
        tabs.setAttribute('role', 'tablist');
        tabs.setAttribute('aria-label', this.i18n.packages);
        const panels = createElement('div', 'order-lookup__package-panels');
        const tabButtons = [];
        const packagePanels = [];

        packages.forEach((packageData, index) => {
          const tabId = `order-lookup-package-tab-${this.sectionId}-${index}`;
          const panelId = `order-lookup-package-panel-${this.sectionId}-${index}`;
          const tab = this.createPackageTab(packageData, index, tabId, panelId);
          const panel = this.createPackage(packageData, index);
          panel.id = panelId;
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', tabId);
          panel.tabIndex = 0;
          panel.hidden = index !== 0;
          tabButtons.push(tab);
          packagePanels.push(panel);
          tabs.append(tab);
          panels.append(panel);
        });

        tabButtons.forEach((tab, index) => {
          tab.addEventListener('click', () => this.activatePackageTab(tabButtons, packagePanels, index));
          tab.addEventListener('keydown', (event) => {
            let nextIndex;
            if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabButtons.length;
            if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabButtons.length) % tabButtons.length;
            if (event.key === 'Home') nextIndex = 0;
            if (event.key === 'End') nextIndex = tabButtons.length - 1;
            if (nextIndex === undefined) return;
            event.preventDefault();
            this.activatePackageTab(tabButtons, packagePanels, nextIndex, true);
          });
        });

        this.packagesSection.append(tabs, panels);
      }

      createPackageTab(packageData, index, tabId, panelId) {
        const tab = createElement('button', 'order-lookup__package-tab');
        tab.type = 'button';
        tab.id = tabId;
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', panelId);
        tab.setAttribute('aria-selected', index === 0 ? 'true' : 'false');
        tab.tabIndex = index === 0 ? 0 : -1;

        const top = createElement('span', 'order-lookup__package-tab-top');
        top.append(
          createElement('span', 'order-lookup__package-tab-name', `${this.i18n.package} ${index + 1}`),
          this.createBadge({ value: packageData.status, text: packageData.statusText })
        );
        tab.append(top);

        const meta = [packageData.carrier, packageData.trackingNumberMasked].filter(Boolean).join(' · ');
        if (meta) tab.append(createElement('span', 'order-lookup__package-tab-meta', meta));
        return tab;
      }

      activatePackageTab(tabs, panels, activeIndex, focusTab = false) {
        tabs.forEach((tab, index) => {
          const isActive = index === activeIndex;
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          tab.tabIndex = isActive ? 0 : -1;
          panels[index].hidden = !isActive;
        });
        if (focusTab) tabs[activeIndex].focus();
      }

      createPackage(packageData, index) {
        const article = createElement('article', 'order-lookup__package');
        const heading = createElement('div', 'order-lookup__package-heading');
        heading.append(
          createElement('h3', '', `${this.i18n.package} ${index + 1}`),
          this.createBadge({ value: packageData.status, text: packageData.statusText })
        );
        article.append(heading);

        const facts = createElement('dl', 'order-lookup__package-facts');
        if (packageData.carrier) facts.append(this.createFact(this.i18n.carrier, packageData.carrier, 'order-lookup__package-fact'));
        if (packageData.trackingNumberMasked) facts.append(this.createFact(this.i18n.trackingNumber, packageData.trackingNumberMasked, 'order-lookup__package-fact'));
        if (packageData.shippedAt) facts.append(this.createFact(this.i18n.shippedAt, this.formatDate(packageData.shippedAt, true), 'order-lookup__package-fact'));
        if (packageData.deliveredAt) facts.append(this.createFact(this.i18n.deliveredAt, this.formatDate(packageData.deliveredAt, true), 'order-lookup__package-fact'));
        if (packageData.estimatedDeliveryDate) facts.append(this.createFact(this.i18n.estimatedDelivery, this.formatDate(packageData.estimatedDeliveryDate, false), 'order-lookup__package-fact'));
        if (facts.children.length) article.append(facts);

        const packageItems = Array.isArray(packageData.items) ? packageData.items : [];
        if (packageItems.length) article.append(this.createPackageItems(packageItems));
        article.append(this.createTimeline(Array.isArray(packageData.trackingTimeline) ? packageData.trackingTimeline : []));
        return article;
      }

      createPackageItems(items) {
        const wrap = createElement('div', 'order-lookup__package-items-wrap');
        wrap.append(createElement('p', 'order-lookup__package-items-title', this.i18n.packageItems));
        const list = createElement('div', 'order-lookup__package-items');
        items.forEach((item) => list.append(this.createItem(item)));
        wrap.append(list);
        return wrap;
      }

      createTimeline(timeline) {
        const wrap = createElement('div', 'order-lookup__timeline-wrap');
        wrap.append(createElement('p', 'order-lookup__timeline-title', this.i18n.trackingTimeline));
        if (!timeline.length) {
          wrap.append(createElement('p', 'order-lookup__empty', this.i18n.noTracking));
          return wrap;
        }
        const list = createElement('ol', 'order-lookup__timeline');
        timeline.slice().sort((first, second) => {
          return new Date(second.happenedAt || 0).getTime() - new Date(first.happenedAt || 0).getTime();
        }).forEach((event) => {
          const item = createElement('li', 'order-lookup__timeline-item');
          const content = createElement('div');
          content.append(createElement('span', 'order-lookup__timeline-status', this.statusText({ value: event.status, text: event.statusText })));
          if (event.message) content.append(createElement('span', 'order-lookup__timeline-message', event.message));
          item.append(
            createElement('span', 'order-lookup__timeline-dot'),
            content,
            createElement('time', 'order-lookup__timeline-date', this.formatDate(event.happenedAt, true))
          );
          list.append(item);
        });
        wrap.append(list);
        return wrap;
      }

      createBadge(status) {
        const value = String(status?.value || '').toUpperCase();
        let modifier = '';
        if (value.includes('DELIVERED') || value === 'PAID' || value === 'FULFILLED') modifier = ' order-lookup__badge--success';
        if (value.includes('TRANSIT') || value.includes('DELIVERY') || value === 'SHIPPED') modifier = ' order-lookup__badge--active';
        if (value.includes('CANCEL')) modifier = ' order-lookup__badge--danger';
        return createElement('span', `order-lookup__badge${modifier}`, this.statusText(status));
      }

      statusText(status) {
        const value = String(status?.value || status || '').toUpperCase();
        const labels = {
          PAID: this.i18n.statusPaid,
          UNFULFILLED: this.i18n.statusUnfulfilled,
          NOT_FULFILLED: this.i18n.statusUnfulfilled,
          PARTIALLY_FULFILLED: this.i18n.statusPartial,
          PARTIAL: this.i18n.statusPartial,
          FULFILLED: this.i18n.statusFulfilled,
          SHIPPED: this.i18n.statusFulfilled,
          IN_TRANSIT: this.i18n.statusInTransit,
          OUT_FOR_DELIVERY: this.i18n.statusOutForDelivery,
          DELIVERED: this.i18n.statusDelivered,
          CANCELLED: this.i18n.statusCancelled,
          CANCELED: this.i18n.statusCancelled
        };
        return labels[value] || status?.text || value.replace(/_/g, ' ') || '—';
      }

      createFact(label, value, className = 'order-lookup__fact') {
        const fact = createElement('div', className);
        fact.append(createElement('dt', '', label), createElement('dd', '', value || '—'));
        return fact;
      }

      formatDate(value, includeTime) {
        if (!value) return '—';
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) return '—';
        const options = includeTime
          ? { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' }
          : { year: 'numeric', month: 'short', day: 'numeric' };
        return new Intl.DateTimeFormat(this.locale, options).format(date);
      }

      safeImageUrl(value) {
        if (!value) return '';
        try {
          const url = new URL(value);
          return url.protocol === 'https:' ? url.toString() : '';
        } catch (_error) {
          return '';
        }
      }

      safeProductUrl(value, handle) {
        let destination = value;
        if (!destination && handle) {
          const rootUrl = String(this.config.rootUrl || '/').replace(/\/?$/, '/');
          destination = `${rootUrl}products/${encodeURIComponent(String(handle))}`;
        }
        if (!destination) return '';
        try {
          const url = new URL(destination, window.location.origin);
          if (url.protocol !== 'https:' || url.origin !== window.location.origin) return '';
          return url.toString();
        } catch (_error) {
          return '';
        }
      }

    }

    if (!customElements.get('order-lookup')) customElements.define('order-lookup', OrderLookup);
  })();

  } catch(e) { console.error(e); }
})();
})();
